import { render, staticRenderFns } from "./AcaoObjetoAcaoForm.vue?vue&type=template&id=511e4e2f&scoped=true"
import script from "./AcaoObjetoAcaoForm.vue?vue&type=script&lang=js"
export * from "./AcaoObjetoAcaoForm.vue?vue&type=script&lang=js"
import style0 from "./AcaoObjetoAcaoForm.vue?vue&type=style&index=0&id=511e4e2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511e4e2f",
  null
  
)

export default component.exports